import { render, staticRenderFns } from "./ProyectosPlanificarForm.vue?vue&type=template&id=216103d6"
import script from "./ProyectosPlanificarForm.vue?vue&type=script&lang=js"
export * from "./ProyectosPlanificarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports